// Phase 11B — Material Symbols retirement, Settings chrome.
//
// The fixed, single-meaning glyphs the Settings tree draws itself (as opposed
// to the data-driven option glyphs in `components/product/optionGlyphs`). They
// live together because the same chevron/close/back shapes are drawn by the
// header, the collapsibles, the menu rows and the constraint editor, and a
// chevron that disagreed with itself between two Settings rows would read as a
// bug. Nothing here is exported outside Settings.
//
// Sizing and stroke come from `.lz-v2-glyph`, so every existing Settings
// font-size rule keeps controlling the rendered box.

function SettingsGlyph({ className = "", children }) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={["lz-v2-glyph", className].filter(Boolean).join(" ")}
    >
      {children}
    </svg>
  );
}

// `expand_more` — collapsed/expanded disclosure. The open state is still
// produced by the existing `rotate(180deg)` rule, not by a second glyph.
export function ChevronDownGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <path d="M6.5 9.5 12 15l5.5-5.5" />
    </SettingsGlyph>
  );
}

// `chevron_right` — "this row opens another screen".
export function ChevronRightGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <path d="M9.5 5.5 16 12l-6.5 6.5" />
    </SettingsGlyph>
  );
}

// `arrow_back` — pops the Settings stack.
export function BackGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <path d="M19.5 12H4.5M10.5 6 4.5 12l6 6" />
    </SettingsGlyph>
  );
}

// `close` — dismisses the drawer, a chip or a row.
export function CloseGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <path d="M6 6l12 12M18 6 6 18" />
    </SettingsGlyph>
  );
}

// `delete` — removes a saved pain issue.
export function TrashGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <path d="M4 6.5h16M9.5 6.5V3.8h5v2.7" />
      <path d="M6.5 6.5l.9 13.2h9.2l.9-13.2" />
      <path d="M10 10.4v5.8M14 10.4v5.8" />
    </SettingsGlyph>
  );
}

// `add` — starts a new pain issue.
export function PlusGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <path d="M12 5.5v13M5.5 12h13" />
    </SettingsGlyph>
  );
}

// `add_circle` / `check_circle` — the unselected/selected affordance on a
// suggested movement row.
export function PlusCircleGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <circle cx="12" cy="12" r="8.4" />
      <path d="M12 8.2v7.6M8.2 12h7.6" />
    </SettingsGlyph>
  );
}

export function CheckCircleGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <circle cx="12" cy="12" r="8.4" />
      <path d="M8.3 12.2 11 14.9l4.7-5.4" />
    </SettingsGlyph>
  );
}

// `psychology` — the AI movement-constraint analysis action.
export function AnalyzeGlyph(props) {
  return (
    <SettingsGlyph {...props}>
      <path d="M9.6 4.5A3.2 3.2 0 0 0 6.7 8.9a3.1 3.1 0 0 0-.6 5.3 3.2 3.2 0 0 0 3.3 4.8" />
      <path d="M14.4 4.5a3.2 3.2 0 0 1 2.9 4.4 3.1 3.1 0 0 1 .6 5.3 3.2 3.2 0 0 1-3.3 4.8" />
      <path d="M12 5v14" />
    </SettingsGlyph>
  );
}
